var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full min-w-full h-full min-h-full"},[_c('router-view',{staticClass:"w-full min-w-full h-full min-h-full"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }